import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ASSET_ICON_CONFIGS } from './constants.js';
import FallbackLogo from './parts/fallback-logo.js';
import Shape from './parts/shape.js';
import { cn } from '../../utils/classnames.js';
function getRandomAssetConfig(key) {
    const checksum = [...key].reduce((sum, char) => sum + (char.codePointAt(0) ?? 0), 0);
    const configs = Object.values(ASSET_ICON_CONFIGS).filter(({ inverted }) => !inverted);
    const { bgColor, bgClassName, fgColor, fgClassName } = configs[checksum % configs.length];
    return { bgColor, bgClassName, fgColor, fgClassName };
}
function AssetIcon({ assetName, displayName, size, className, monochrome = false, noShadow = false, shape = 'squared', stacked = false, onUnknownName, }) {
    let config = ASSET_ICON_CONFIGS[assetName];
    if (!config) {
        config = getRandomAssetConfig(assetName);
        onUnknownName?.(assetName);
    }
    const { Logo, bgClassName, fgClassName, logoSizeClassName = 'ui-size-[55%]', inverted, } = config;
    return (_jsxs("div", { className: "ui-relative ui-isolate ui-flex ui-justify-center", children: [_jsx(Shape, { bgClassName: bgClassName, className: cn(stacked && 'ui-z-[1]', className), inverted: inverted, monochrome: monochrome, noShadow: noShadow, shape: shape, size: size, children: _jsx("div", { className: cn('ui-relative ui-z-[1] ui-flex ui-items-center ui-justify-center', size > 16 ? logoSizeClassName : 'ui-size-[60%]'), children: Logo ? (_jsx(Logo, {})) : (_jsx(FallbackLogo, { className: fgClassName, displayName: displayName, fontSize: size * 0.3 })) }) }), stacked && (_jsx(Shape, { bgClassName: bgClassName, className: "!ui-absolute ui-bottom-[-3px]", shape: shape, size: size * 0.85 }))] }));
}
export default AssetIcon;
